/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Režňák (reznak@cadwork.cz)
 */

import Scene from "js_interface/src/scene_interface";
import Plane from "App/environment/objects/plane";
import MovableObject from "App/environment/movable_object";
import Pass from "App/render/webgl/passes/pass";

/**
 * Difference between this and Plane
 *  - 2 images, one for front and second for back
 *
 * @param {SceneAPI.Scene} sceneAPI
 * @param {WebGLRenderingContext} gl
 * @extends MovableObject
 * @constructor
 */
export default
class Plane2 extends MovableObject {
    private _front: Plane;
    private _back: Plane;

    constructor(sceneAPI: Scene, gl: WebGLRenderingContext) {
        super();

        this._front = new Plane(sceneAPI, gl);

        this._back = new Plane(sceneAPI, gl);
        this._back.addRotation(0, Math.PI, 0, true);
    }
    public getBack(): Plane {
        return this._back;
    }

    public getFront(): Plane {
        return this._front;
    }

    public setAlpha(a: number) {
        this._front.setAlpha(a);
        this._back.setAlpha(a);
    }

    /**
     * @param {Pass} renderPass
     * @param {number} [iCount = 1] Number of instances
     */
    public draw(renderPass: Pass, iCount: number): void {

        if (!this._modelMatrixValid) {
            this._modelMatrixValid = true;

            this._front.setPositionVec(this.getPosition());
            this._front.setRotationQuat(this.getRotation());
            this._front.setScaleVec(this.getScale());

            this._back.setPositionVec(this.getPosition());
            this._back.setRotationQuat(this.getRotation());
            this._back.addRotation(0, Math.PI, 0, true);
            this._back.setScaleVec(this.getScale());
        }

        this._front.draw(renderPass, iCount);
        this._back.draw(renderPass, iCount);
    }
}

